var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { CUSTOMER_STATE } from '@variables';
export var AuthContext = createContext(undefined);
export var AuthProvider = function (_a) {
    var children = _a.children;
    var isLoggedIn = Boolean(window.customer_key);
    var isFoodSubscriber = window.customer_state === CUSTOMER_STATE.IS_FOOD_SUBSCRIBER;
    return (_jsx(AuthContext.Provider, __assign({ value: { isLoggedIn: isLoggedIn, isFoodSubscriber: isFoodSubscriber } }, { children: children })));
};
export var useAuthContext = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within a AuthProvider');
    }
    return context;
};
